export default __webpack_public_path__ + "static/media/goldengatebridge.895a909a.jpg";